// 邀請相關翻譯

export const invites = {
    invitationCode: '邀請碼',
    enterInvitationCode: '輸入邀請碼',
    copied: '已複製！',
    copyInvitationLink: '複製邀請連結',
    inviteRewardDescription: '邀請1位好友注册 Catoo，獎勵{amount}積分，好友消費更有額外積分獎賞。',
    invitationRewardBalance: '獎勵積分',
    totalInvitationCount: '總邀請數',
    monthlyReferrals: '本月邀請數',
    totalPaidCount: '總付費數',
    totalAwardAmount: '總獎勵金額',
    registrationReward: '註冊獎勵',
    invitationReward: '好友消費獎勵',
    invitationRecords: '邀請記錄',
    invitationTime: '邀請時間',
    invitedUser: '被邀請用戶',
    email: '郵箱',
    status: '狀態',
    rewardAmount: '獎勵金額',
    rewardCredits: '獎勵積分',
    unknownUser: '未知用戶',
    completed: '已完成',
    pending: '待完成',
    noInvitationRecords: '暫無邀請記錄'
  };
